import React from 'react'
import { useTranslation } from 'react-i18next'

import { AvatarImage, TAvatarImageProps } from 'modules/user/components/AvatarImage'
import { useUser } from 'modules/user/hooks/useUser'

export type TUserAvatarProps = TAvatarImageProps & {
  userId: number
} & Omit<TAvatarImageProps, 'alt'>

export const UserAvatar: TFCC<TUserAvatarProps> = ({ userId, ...otherProps }) => {
  const user = useUser({ userId })
  const { t } = useTranslation()

  return (
    <AvatarImage
      avatar={user?.avatar}
      alt={user?.name && t('common:user.avatar.image-alt', { name: user.name })}
      {...otherProps}
    />
  )
}
